import React, { useEffect, useState, useCallback } from "react";
import { convertDate } from "./helpers";
import { itSelfEmpty } from "utils/all";
import { instance2 } from "App/constants";
import { Skeleton } from "@material-ui/lab";
import { Grid, Paper } from "@material-ui/core";
// import { getUserName } from "App/utils/cookies";
import { FreezeTable } from "components/organism";
import { STYLE_DEFAULT_MASTER } from "App/constants/theme"
import { useDatatables, useDatatablesServerSide } from "App/hooks";
import { defaultToastError, defaultToastSuccess } from "App/utils/helpers";
import { getComparator, stableSort, } from "App/Component/ui/datatable/utils";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TableCell,
  TableRow,
  Typography,
} from "@material-ui/core";

import {
  STATE_FILTER_BED,
  getListAllKelasSirsOL,
  headCellsAllSirsOnline,
  headCellsReferensiSirsOnline,
  urlUpdateKelasKamarSirsOnline
} from "App/Component/layout/MasterData/Bed/ui/TabKelasKamarSirsOnline/helpers";

import {
  MasterButton,
  Modal,
  // TableAction,
  DatatablesFooterServerSide,
  InputTextMaster,
} from "App/Component/ui";

export default function DialogRsOL({ setShowModal, dataReferensi }) {
  const classes = STYLE_DEFAULT_MASTER()

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalData, setTotalData] = useState(0);
  const [selected, setSelected] = useState({});
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);
  const [formFilterBed, setFormFilterBed] = useState(STATE_FILTER_BED);

  const setNewData = useCallback(async (
    pages = formFilterBed.pages,
    limit = formFilterBed.limit
  ) => {
    setLoading(true);
    try {
      const resListAll = await getListAllKelasSirsOL(formFilterBed, pages, limit);

      if (resListAll.state) {
        setRows(resListAll.data);
        setTotalData(resListAll.meta.count);
      } else {
        setRows([]);
        defaultToastError(resListAll.message);
      }
    } catch (error) {
      defaultToastError("Gagal memuat data");
    } finally {
      setLoading(false);
    }
  }, [formFilterBed]);

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
  } = useDatatablesServerSide({ setNewData: setNewData });

  const searchKey = formFilterBed?.search_key || "";
  const filteredData = searchKey === ""
    ? rows
    : itSelfEmpty(rows, []).filter(
      (row) =>
        row?.ruang
          .split(" ")
          .join()
          .toLowerCase()
          .includes(
            formFilterBed.search_key.split(" ").join().toLowerCase()
          ) ||
        row?.id_t_tt
          .split(" ")
          .join()
          .toLowerCase()
          .includes(
            formFilterBed.search_key.split(" ").join().toLowerCase()
          )
    );

  const handleDelete = async (row) => {
    try {
      const payload = {
        name: row?.tt,
        id_hapus: row?.id,
        kodebridgingsirs: !row.id_tt ? "" : row.id_tt,
        status_update: "hapus_external",
        remark: !row.remark ? "" : row.remark,
      };

      const response = await instance2.put(urlUpdateKelasKamarSirsOnline, payload);
      if (response.status === 200) {
        defaultToastSuccess(response.data?.message);
        setNewData();
      } else {
        defaultToastError(response.data?.message);
      }
    } catch (error) {
      defaultToastError("gagal menghapus data");
    }

    setShowModalDeleteConfirm(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      await setNewData();
    };

    fetchData();
  }, [setNewData]);

  return (
    <>
      {/* dialog before delete */}
      <Dialog
        open={showModalDeleteConfirm}
        onClose={() => {
          setShowModalDeleteConfirm(false);
        }}
      >
        <FormDialogDelete
          selected = {selected}
          handleDelete = {handleDelete}
        />
      </Dialog>

      {/* modal list RS OL */}
      <Modal width="80%" show={setShowModal} title="LIST KLS RS OL">
        <Grid direction="column" spacing={3}>
          <Grid item style={{ marginBottom: "24px" }}>
            <Paper
              className={classes.paper}
              style={{
                padding: "1rem",
              }}
            >
              <div
                style={{
                  width: "250px",
                  paddingBottom: "15px",
                }}
              >
                <p style={{ fontWeight: "bold" }}>REFERENSI RS OL</p>
              </div>
              <TableListReferensiRsOL
                dataReferensi={dataReferensi}
                loading={loading}
              />
            </Paper>
          </Grid>

          <Grid item>
            <Paper
              className={classes.paper}
              style={{
                padding: "1rem",
              }}
            >
              <div
                style={{
                  width: "250px",
                  paddingBottom: "15px",
                }}
              >
                <p style={{ fontWeight: "bold" }}>LIST RUANG RS OL</p>
              </div>
              <div style={{ width: "250px", paddingBottom: "15px", }}>
                <InputTextMaster
                  name="search_key"
                  label="Cari"
                  value={formFilterBed.search_key}
                  onChange={(e) =>
                    setFormFilterBed({ ...formFilterBed, search_key: e.target.value })
                  }
                  id="search_key"
                />
              </div>
              <TableListRuangRsOL
                rows={filteredData}
                loading={loading}
                setSelected={setSelected}
                setShowModalDeleteConfirm={setShowModalDeleteConfirm}
                showModalDeleteConfirm={showModalDeleteConfirm}
              />
              <DatatablesFooterServerSide
                totalData={totalData}
                pagination={pagination}
                handleChangeLimit={handleChangeLimit}
                onPrevious={onPrevious}
                onNext={onNext}
                currentPage={pagination.page}
                handleClickPageNumber={handleClickPageNumber}
              />
            </Paper>
          </Grid>
        </Grid>
      </Modal>
    </>
  );
}

const TableListRuangRsOL = ({ rows, loading, setSelected, setShowModalDeleteConfirm, showModalDeleteConfirm }) => {
  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rows,
    orderByDefault: "id_tt",
    orderByRow: ["id_tt"],
  })

  return (
    <FreezeTable
      headCells={headCellsAllSirsOnline}
      handleRequestSort={handleRequestSort}
      order={order}
      length={length}
      orderBy={orderBy}
    >
      {loading ? (
        Array.from({ length: 15 }).map((itm) => (
          <TableRow>
            {headCellsAllSirsOnline.map((item) => (
              <TableCell>
                <Skeleton animation="wave" />
              </TableCell>
            ))}
          </TableRow>
        ))
      ) : (
        <>
          {stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
            return (
              <TableRow hover key={index}>
              <TableCell align="center">{index + 1}</TableCell>
              {/* <TableCell align="center">
                <TableAction
                  clickDelete={() => {
                    setSelected(row);
                    setShowModalDeleteConfirm(!showModalDeleteConfirm);
                  }}
                  isUpdate={false}
                />
              </TableCell> */}
              <TableCell align="center">
                {row.id_tt ?? " - "}
              </TableCell>
              <TableCell align="center">
                {row.id_t_tt ?? " - "}
              </TableCell>
              <TableCell align="center">
                {row.tt ?? " - "}
              </TableCell>
              <TableCell align="center">
                {row.ruang ?? " - "}
              </TableCell>
              <TableCell align="center">
                {row.jumlah_ruang ?? " - "}
              </TableCell>
              <TableCell align="center">
                {row.jumlah ?? " - "}
              </TableCell>
              <TableCell align="center">
                {row.terpakai_suspek ?? " - "}
              </TableCell>
              <TableCell align="center">
                {row.terpakai_konfirmasi ?? " - "}
              </TableCell>
              <TableCell align="center">
                {row.terpakai_dbd ?? " - "}
              </TableCell>
              <TableCell align="center">
                {row.terpakai_dbd_anak ?? " - "}
              </TableCell>
              {/* <TableCell align="center">
                {row.terpakai ?? " - "}
              </TableCell>
              <TableCell align="center">
                {row.antrian ?? " - "}
              </TableCell> */}
              <TableCell align="center">
                {convertDate(row.tglupdate) ?? " - "}
              </TableCell>
            </TableRow>
            )
          })}
          {rows.length === 0 && (
            <TableRow>
              <TableCell align="center" colSpan={headCellsAllSirsOnline.length}>
                Tidak ada data
              </TableCell>
            </TableRow>
          )}
        </>
      )}
    </FreezeTable>
  )
}

const TableListReferensiRsOL = ({ dataReferensi, loading }) => {
  const {
    order: orderReferensi,
    orderBy: orderByReferensi,
    handleRequestSort: handleRequestSortReferensi,
    length: lengthReferensi,
  } = useDatatables({
    rows: itSelfEmpty(dataReferensi, []),
    orderByDefault: "nama_tt",
    orderByRow: ["kode_tt", "nama_tt"],
  });

  return (
    <FreezeTable
      headCells={headCellsReferensiSirsOnline}
      handleRequestSort={handleRequestSortReferensi}
      length={lengthReferensi}
      order={orderReferensi}
      orderBy={orderByReferensi}
    >
      {loading ? (
        Array.from({ length: 3 }).map((_, i) => (
          <TableRow key={i}>
            {headCellsReferensiSirsOnline.map((item, j) => (
              <TableCell key={j}>
                <Skeleton animation="wave" />
              </TableCell>
            ))}
          </TableRow>
        ))
      ) : (
        <>
          {stableSort(dataReferensi, getComparator(orderReferensi, orderByReferensi)).map(
            (row, index) => (
              <TableRow hover key={row.kode_tt || index}>
                <TableCell align="center">{index + 1}</TableCell>
                <TableCell align="center">{row.kode_tt ?? " - "}</TableCell>
                <TableCell align="left">{row.nama_tt ?? " - "}</TableCell>
              </TableRow>
            )
          )}
          {dataReferensi.length === 0 && (
            <TableRow>
              <TableCell align="center" colSpan={headCellsReferensiSirsOnline.length}>
                Tidak ada data
              </TableCell>
            </TableRow>
          )}
        </>
      )}
    </FreezeTable>
  );
};

const FormDialogDelete = ({ selected, handleDelete }) => {
  return (
    <>
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">Konfirmasi Hapus</DialogTitle>
      <DialogContent dividers>
        <Typography gutterBottom>
          Harap konfirmasi hapus data kelas RS OL dengan data berikut:
        </Typography>
        <Typography gutterBottom variant="caption">
          ID TT: {selected.id_tt}
        </Typography>
        <br />
        <Typography gutterBottom variant="caption">
          ID T-TT: {selected.id_t_tt}
        </Typography>
        <br />
        <Typography gutterBottom variant="caption">
          TT: {selected.tt}
        </Typography>
      </DialogContent>
      <DialogActions>
        <MasterButton
          name="Hapus"
          color="danger"
          type="button"
          onClick={() => handleDelete(selected)}
        />
      </DialogActions>
    </>
  )
}
